<!--
 * @Author: 汪鑫
 * @Description:发布页弹窗/申请单位信息组件
-->
<template>
  <div class="applicantInformation clearfix">
    <el-row>
      <!-- 经办人信息 -->
      <el-form
        :model="handleInfo"
        :rules="rules"
        ref="applicantRule"
        :label-width="labelW +'px'"       
      >
        <el-col :span="8">
          <el-form-item
            label="申请单位"
            prop="companyName"
            style="margin-bottom: 0"
          >
            <TreeSelectInput
              :treeData="comTreeData"
              :defaultProps="{ children: 'children', label: 'name' }"
              :defaultCheckData="comDefaultCheckData"
              :value.sync="handleInfo.companyName"
              nodeKey="id"
              @changeSelect="comChangeSelect"
              placeholder="请选择申请单位"
              :width="inputW"
            >
            </TreeSelectInput>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="申请部门"
            prop="departmentName"
          >
            <TreeSelectInput
              key="dep"
              :treeData="depTreeData"
              :defaultProps="{ children: 'children', label: 'name' }"
              :defaultCheckData="depDefaultCheckData"
              :value.sync="handleInfo.departmentName"
              nodeKey="id"
              @changeSelect="depChangeSelect"
              placeholder="请选择申请部门"
              :width="inputW"
            >
            </TreeSelectInput>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="经办人" prop="userNo" label-width="66px">
            <el-cascader
              ref="cascader"
              :style="{width: inputW +'px'}"
              class="tree-cascader"
              v-model="handleInfo.userNo"
              :placeholder="agentPlaceholder"
              @change="agentChange"
              @focus="agentFocus"
              :options="agentOptions"
              :disabled="disabled"
              :props="propsType"
            ></el-cascader>            
            <span v-show="form.addFieldListTwo && !form.addFieldListTwo.length" class="addFiledBtn" @click="addCustomizeField(form.addFieldListTwo)"><i class="el-icon-plus"></i>新增</span>
          </el-form-item>
        </el-col>
      </el-form>
      <!-- 新增字段 -->
       <el-form
        :model="form"
        label-width="0px" 
        ref="addFiledArr"      
      >
         <template
            v-for="(item, index) in  form.addFieldListTwo"                      
          >
            <el-col :key="index" :span="8" class="addNewFiled">
             <el-form-item   
                 :prop="'addFieldListTwo.' + index + '.title'"
                 :rules="{
                   required: true,
                   message: '请输入标题',
                   trigger: 'blur',
                 }" 
                 label-width="0px" 
                 style="margin-right:5px;margin-left:10px">
               <el-input
                 style="width:100px"
                 maxlength="20"
                 autocomplete="off"
                 placeholder="请输入标题"
                 v-model.trim="item.title"
               ></el-input>
             </el-form-item>
             <el-form-item  
                label-width="0px"
                :prop="'addFieldListTwo.' + index + '.value'"
                 :rules="{
                   required: true,
                   message: '请输入内容',
                   trigger: 'blur',
                 }" >
               <el-input
                 style="width: 164px"
                 maxlength="200"
                 autocomplete="off"
                 placeholder="请输入内容"
                 v-model.trim="item.value"
               ></el-input>
               <span @click="removeNewFiled(index)">
                 <el-icon class="el-icon-delete delete-icon"></el-icon>
               </span>
               <span class="addFiledBtn" v-show='form.addFieldListTwo.length-1==index'  @click="addCustomizeField(form.addFieldListTwo)">
                <i class="el-icon-plus"></i>新增
               </span>
             </el-form-item>
            </el-col>
         </template>
       </el-form>
    </el-row>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
export default {
  name: "ApplicantInfoComponent",
  props: {
    /* 表单数据 */
    ruleForm: {
      type: Object,
      default() {
        return {}
      }
    },
    /* 经办人信息 */
    handleInfoDto: {
      type: Object,
      default() {
        return {}
      }
    },
    /* 用户身份 */
    type: {
      type: [Number, String],
      default: 1 /* 1是企业，2是团队 */
    },
    /* 是否新增 true是新增 */
    isAdd: {
      type: Boolean,
      default: true
    },
    /* 表单宽度 */
    labelW: {
      type: Number,
      default: 100
    },
    /* 经办信息输入框宽度 */
    inputW: {
      type: Number,
      default: 200
    },
  },
  components: {
    TreeSelectInput: () => import("@/components/public/components/treeSelectInput.vue"), //下拉树组件框
  },
  data() {
    return {
      form: {},
      handleInfo:{companyName:'',userNo:[]},
      totalData: [], //公司组织架构数据
      comTreeData: [], //公司数据
      depTreeData: [], //部门数据
      comDefaultCheckData: [], //默认公司数据
      depDefaultCheckData: [], //默认部门数据
      disabled: false, //经办人框是否禁用
      agentPlaceholder: "请选择经办人",
      propsType: { label: "name", value: "memberNo", checkStrictly: true },
      agentOptions: [], //人员数据
      rules: {
        //表单验证规则
        companyName: [
          { required: true, trigger: "change", message: "请选择申请单位" },
        ],
        departmentName: [
          { required: true, trigger: "blur", message: "请选择申请部门" },
        ],
        userNo: [{ required: true, trigger: "blur", message: "请选择经办人" }],
      },
    };
  },
   methods: {
    /* 验证表单必填 */
    async validatorform() {
      let result = [];
      result.push(this.$refs["applicantRule"].validate());
      result.push(this.$refs.addFiledArr.validate());
      await Promise.all(result)
        .then(() => {
          result = true;
        })
        .catch(() => {
          result = false;
        });
      return result;
    },
    //初始化数据
     initData() {
      this.$nextTick(async() => {
        this.form = this.ruleForm;
        this.handleInfo=this.handleInfoDto
     /* 企业身份 */
      if(this.type==1){
        let result = await apiResignAll.getOrganizational();
        if (result && result.data.code == 200) {
            this.totalData = result.data.data; //得到公司组织架构数据
            this.comTreeData = this.getCompanyData(result.data.data); //得到公司数据
          }
      }else if(this.type==2){//团队身份
          let res = await apiResignAll.getTeamOrganizational();
        if (res && res.data.code == 200) {
            this.totalData = res.data.data; //得到公司组织架构数据
            this.comTreeData = this.getCompanyData(res.data.data); //得到公司数据
          }
      }
      /* 团队身份没有默认显示 */
      if(this.type==1){
        this.comDefaultCheckData = [this.handleInfo.companyNo]; //激活默认选中申请公司
        this.depDefaultCheckData = this.handleInfo.departmentNo ? [this.handleInfo.departmentNo]:[this.handleInfo.companyNo]; //激活默认选中部门公司
        this.handleInfo.departmentName = this.handleInfo.departmentName? this.handleInfo.departmentName: "未分配部门";
        this.handleInfo.departmentNo = this.handleInfo.departmentNo? this.handleInfo.departmentNo: this.handleInfo.companyNo;
        this.getUserData( this.handleInfo.departmentNo); //获取经办人数据
        if (this.handleInfo.companyNo == 1) {
          /* 总公司 */
          this.depTreeData = [...this.getDepartmentData(this.totalData[0]), { name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
        } else {
          /* 子公司 */
          this.findDepartment(this.totalData, this.handleInfo.companyNo); //拿到子公司数据
           if(!this.obj.children.length){
            this.depTreeData = [{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }else{
            this.depTreeData = [...this.getDepartmentData(this.obj),{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }
        }
      }else if(this.type==2 && !this.isAdd) {//编辑回显数据        
          this.comDefaultCheckData = [this.handleInfo.companyNo]; //激活默认选中申请公司
          this.depDefaultCheckData = this.handleInfo.departmentNo ? [this.handleInfo.departmentNo]:[this.handleInfo.companyNo]; //激活默认选中部门公司
          this.handleInfo.departmentName = this.handleInfo.departmentName? this.handleInfo.departmentName:this.handleInfo.companyNo?"未分配部门":"" ;
          this.handleInfo.departmentNo = this.handleInfo.departmentNo? this.handleInfo.departmentNo: this.handleInfo.companyNo;
          if(this.handleInfo.companyNo){  //团队无默认
            this.getUserData( this.handleInfo.departmentNo); //获取经办人数据
            if (this.handleInfo.companyNo == 1) {
            /* 总公司 */
            this.depTreeData = [...this.getDepartmentData(this.totalData[0]), { name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          } else {
            /* 子公司 */
            this.findDepartment(this.totalData, this.handleInfo.companyNo); //拿到子公司数据
             if(!this.obj.children.length){
            this.depTreeData = [{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }else{
            this.depTreeData = [...this.getDepartmentData(this.obj),{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }
        }
          }
      }    
       });
    },

    /* 递归函数拿到公司数据 */
    getCompanyData(data) {
      let that = this;
      return data
        .filter((item) => {
          return item.type == 0 || item.type == 2; //过滤条件(去掉部门数据)
        })
        .map((item) => {
          item = Object.assign({}, item);
          if (item.children) {
            item.children = that.getCompanyData(item.children);
          }
          return item;
        });
    },

    /* 拿到总公司部门数据 */
    getDepartmentData(data) {
      if (data.children && data.children.length) {
        return data.children.filter((item) => {
          return item.type == 1; //过滤条件(公司部门)
        });
      }
    },

    /* 根据子公司id递归数据拿到子公司的数据 */
    findDepartment(tree, id) {
      tree.forEach((item) => {
        if (item.id == id) {
          this.obj = item; // 结果赋值
        } else {
          if (item.children) {
            this.findDepartment(item.children, id);
          }
        }
      });
    },

    /* 取到选中公司数据 */
    comChangeSelect(data) {
      this.handleInfo.companyNo = data.id; //拿到公司id
      this.handleInfo.departmentName = ""; //置空申请部门
      this.handleInfo.userNo = []; //置空经办人
      this.agentPlaceholder="请选择经办人"  //将占位文本设成经办人
      if (data.type == 0) {
        /* 选的总公司 */
        this.depTreeData = [...this.getDepartmentData(this.totalData[0]),{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
      } else {
        /* 选的子公司 */
        this.findDepartment(this.totalData, data.id); //拿到子公司数据
        if(!this.obj.children.length){
            this.depTreeData = [{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }else{
            this.depTreeData = [...this.getDepartmentData(this.obj),{ name: "未分配部门", id: this.handleInfo.companyNo },]; //拿到子公司部门
          }
      }
    },
    /* 取到选中部门数据 */
    async depChangeSelect(data) {
      this.$refs["applicantRule"].fields[1].clearValidate();
      this.handleInfo.departmentNo = data.id; //拿到部门id
      this.disabled = false; //激活经办人输入框
      this.handleInfo.userNo = []; //置空经办人
      this.getUserData(data.id)
      this.handleInfo.userName = "请选择经办人"; //修复再次选择部门，经办人会回显初始值
      this.agentPlaceholder="请选择经办人"  //将占位文本设成经办人
        
    },
    /* 获取人员数据 */
    async getUserData(id) {
      if(this.type==1){
        let result = await apiResignAll.getOrganizationalPepole(id);
        if (result && result.data.code == 200) {
            this.agentOptions = result.data.data.records; //拿到部门人员数据
            /* 处理组织架构删除该部门这个人，数据不回显问题 */
            if(!this.agentOptions.filter((item, index) => item.memberNo== this.handleInfo.userNo).length){
              this.agentPlaceholder=this.handleInfo.userName  //将占位文本设成经办人
            }
        }
      }else if(this.type==2){
        let res = await apiResignAll.getTeamOrganizationalPepole(id);
        if (res && res.data.code == 200) {
            this.agentOptions = res.data.data.records; //拿到部门人员数据
            /* 处理组织架构删除该部门这个人，数据不回显问题 */
            if(!this.agentOptions.filter((item, index) => item.memberNo== this.handleInfo.userNo).length){
              this.agentPlaceholder=this.handleInfo.userName  //将占位文本设成经办人
            }
        }
      }
    },
    /* 经办人输入框聚焦 */
    agentFocus(e) {
      if (!this.handleInfo.departmentName) {
        this.disabled = true;
        this.$message.warning("请选择申请部门");
        }
        else if(!this.agentOptions.length){
        this.disabled = true;
        this.$message.warning("该部门暂无人员，请重新选择部门");
      }
    },
    /* 经办人选择后关闭弹框 */
    agentChange(val) {
      this.handleInfo.userName = this.$refs.cascader.getCheckedNodes()[0].label; //拿到经办人
      this.$refs["applicantRule"].fields[2].clearValidate();
      this.$refs.cascader.dropDownVisible = false;
    },

    /**@name 新增自定义字段 */
      addCustomizeField(addField) {
      if (addField.length < 5) {
        const isHaveInstance = addField.some((item) => !item.title && !item.value);
        const isHaveKey = addField.some((item) => !item.title);
        const isHaveValue = addField.some((item) => !item.value);
        if(isHaveInstance || isHaveKey || isHaveValue){
          this.$message({message: "请先填写新增字段内容",type: "warning",center: true,});
        }else{addField.push({title: "",value: "",key: this.uuid(),});}
      } else {
        this.$message({message: "最多只能新增五个字段",type: "warning",center: true,});
      }
    },
    // 移除新增字段
    removeNewFiled(i) {
      this.form.addFieldListTwo.splice(i, 1);
    },
    /* 生成uuid */
    uuid(len, radix) {
      let CHARS =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
          ""
        );
      let chars = CHARS,
        uuid = [],
        i;
      radix = radix || chars.length;

      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
      } else {
        let r;

        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";

        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join("");
    },
  },
  mounted() {
    this.initData();
  },
  watch: {
    "handleInfo.departmentName"(val, oldVal) {
      if (val) {
        this.disabled = false; //经办人选择框启用
      }
    },
    form: {
      handler() {
        this.ruleForm = this.form;
        this.$emit("update:ruleForm", this.ruleForm);
      },
      deep: true,
    },
    handleInfo: {
      handler () {
        this.handleInfoDto = this.handleInfo;
        this.$emit("update:handleInfoDto", this.handleInfo);
      },
      deep: true,
    },
    ruleForm: {
      handler() {
        this.form = this.ruleForm;
        this.handleInfo=this.ruleForm.handleInfoDto
        // this.initData();
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  /deep/.el-input__inner{
    height: 34px;
    color: #000;
    padding-left: 10px;
  }
   /deep/.el-form-item__label{
    color:#333 ;
  }
  /deep/.el-textarea__inner{
    color: #000;
    padding-left: 10px;
  }
  /deep/.el-form-item__label ,/deep/.el-input__icon {
    line-height: 34px;
  }
  /deep/.el-form-item__content{
    line-height: 34px;
  }
  /deep/ .el-cascader{
    line-height: 34px;
  }
.bottom{
  margin-bottom: 15px;
}
.addFiledBtn{
  margin-left: 10px;
  color: #b79255;
  cursor: pointer;
  user-select: none;
}
.addNewFiled{
  display: flex;
  .delete-icon{
    margin-left: 8px;
    font-size: 15px;
    color: #e1251b;
    cursor: pointer;
  }
}
  /deep/.add-customize-field .new-add-box{
    margin-bottom: 15px !important;
  }

/deep/.el-col-8{
  &:not(:first-child){
    &:after{     
      content:''!important;
      display: unset !important;
    }
  }
}
</style>